import { BACKEND_URL } from "../env";
import { ApiError } from "../types/api-error";
import { BillingAddress } from "../types/entities";

export async function fetchBillingAddress(
  clientId: string
): Promise<BillingAddress | null> {
  if (!clientId) return null;
  try {
    const response = await fetch(
      `${BACKEND_URL}/billing-addresses?clientId=${encodeURIComponent(clientId)}`,
      { credentials: "include", cache: "no-store" }
    );
    if (response.status >= 400) return null;
    const data = await response.json();
    if (data && "billingAddress" in data && data.billingAddress === null) {
      return null;
    }
    return data as BillingAddress;
  } catch {
    return null;
  }
}

export async function saveBillingAddress(
  clientId: string,
  address: Omit<BillingAddress, "id">
): Promise<{ success: boolean; address?: BillingAddress; error?: ApiError }> {
  try {
    const response = await fetch(`${BACKEND_URL}/billing-addresses`, {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ clientId, ...address }),
    });
    if (response.status >= 400) {
      const errorData = await response.json().catch(() => ({}));
      const code =
        errorData?.code ??
        (response.status === 409
          ? "conflict"
          : response.status === 404
            ? "not_found"
            : undefined);
      const message = errorData?.message || "Failed to save billing address.";
      return {
        success: false,
        error: { status: response.status, code, message },
      };
    }
    const saved = (await response.json()) as BillingAddress;
    return { success: true, address: saved };
  } catch {
    return {
      success: false,
      error: { message: "Network error. Please try again." },
    };
  }
}
